import React, { PropTypes } from 'react';

import {
  childrenStyle,
  container,
  lowText,
  text,
  underscore,
  underscoreSlim,
} from './styles.module.css';

/**
 * Underscore presentational component.
 */
const Underscore = ({
  children,
  className,
  low,
  slim,
}) => (
  <div className={[container, className].join(' ')}>
    <div className={low ? lowText : text}>
      <div className={childrenStyle}>
        {children}
      </div>
    </div>
    <div className={slim ? underscoreSlim : underscore} />
  </div>
);

export default Underscore;

Underscore.propTypes = {
  /**
   * Children contents of container.
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  /**
   * Bool to determine if text should sit closer to underscore or not.
   */
  low: PropTypes.bool,
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Boolean to render slimmer style underscore.
   */
  slim: PropTypes.bool,
};

Underscore.defaultProps = {
  className: '',
  low: false,
  slim: false,
};



// WEBPACK FOOTER //
// ./app/src/components/Underscore/index.jsx